/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        toggle: {
            checked: {
                default: {
                    bar: {
                        backgroundColor: {
                            value: "#282e37",
                            type: "color",
                        },
                        borderColor: {
                            value: "#282e37",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                },
                hover: {
                    bar: {
                        backgroundColor: {
                            value: "#464e53",
                            type: "color",
                        },
                        borderColor: {
                            value: "#464e53",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                },
                active: {
                    bar: {
                        backgroundColor: {
                            value: "#282e37",
                            type: "color",
                        },
                        borderColor: {
                            value: "#282e37",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                },
                disabled: {
                    bar: {
                        backgroundColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        borderColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                },
            },
            unchecked: {
                default: {
                    bar: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderColor: {
                            value: "#282e37",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#282e37",
                            type: "color",
                        },
                    },
                },
                hover: {
                    bar: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderColor: {
                            value: "#464e53",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#464e53",
                            type: "color",
                        },
                    },
                },
                active: {
                    bar: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderColor: {
                            value: "#282e37",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#282e37",
                            type: "color",
                        },
                    },
                },
                disabled: {
                    bar: {
                        backgroundColor: {
                            value: "#ffffff",
                            type: "color",
                        },
                        borderColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                        borderWidth: {
                            value: "1px",
                            type: "dimension",
                        },
                        borderStyle: {
                            value: "solid",
                            type: "strokeStyle",
                        },
                    },
                    knob: {
                        backgroundColor: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                    },
                },
            },
            small: {
                bar: {
                    height: {
                        value: "16px",
                        type: "dimension",
                    },
                    width: {
                        value: "33px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "8px",
                        type: "dimension",
                    },
                    padding: {
                        value: "3px",
                        type: "dimension",
                    },
                },
                knob: {
                    height: {
                        value: "10px",
                        type: "dimension",
                    },
                    width: {
                        value: "10px",
                        type: "dimension",
                    },
                },
            },
            large: {
                bar: {
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                    width: {
                        value: "46px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                    padding: {
                        value: "4px",
                        type: "dimension",
                    },
                },
                knob: {
                    height: {
                        value: "16px",
                        type: "dimension",
                    },
                    width: {
                        value: "16px",
                        type: "dimension",
                    },
                },
            },
            label: {
                color: {
                    value: "#282e37",
                    type: "color",
                },
                fontSize: {
                    value: "0.875rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "number",
                },
                letterSpacing: {
                    value: "0.2px",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                leading: {
                    paddingRight: {
                        value: "12px",
                        type: "dimension",
                    },
                },
                trailing: {
                    paddingLeft: {
                        value: "12px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
